import decode from 'jwt-decode';

export interface ITokenPayload {
  AccountId: string;
  UserRole: string;
  sub: string;
  Email: string;
  TokenType: string;
  SignerId: string;
  EvelopeId: string;
  nbf: number;
  exp: number;
  iat: number;
  iss: string;
}

export let tokenInfo: ITokenPayload;

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const decodeToken = (token: string) => {
  tokenInfo = decode(token);
};
